import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { G, Path, Rect, Circle, Defs, LinearGradient, Stop, ClipPath } from "react-native-svg"

function SvgImageIcon(props) {
    return (
        <Svg width={40} height={50} viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <G clipPath="url(#clip0)">
                <Path d="M0 5a5 5 0 015-5h30a5 5 0 015 5v40a5 5 0 01-5 5H5a5 5 0 01-5-5V5z" fill="#E6F4F4" />
                <Rect
                    x={5.57129}
                    y={28}
                    width={39.4397}
                    height={49.5289}
                    rx={5}
                    transform="rotate(41.12 5.571 28)"
                    fill={baseColors.green.pastel}
                />
                <Rect
                    x={5.57129}
                    y={28}
                    width={39.4397}
                    height={49.5289}
                    rx={5}
                    transform="rotate(41.12 5.571 28)"
                    fill="url(#paint0_linear)"
                />
                <Rect
                    x={24.5117}
                    y={23}
                    width={43}
                    height={54}
                    rx={5}
                    transform="rotate(41.12 24.512 23)"
                    fill={baseColors.green.primary}
                />
                <Circle cx={9.5} cy={17.5} r={3.5} fill={baseColors.green.primary} />
            </G>
            <Defs>
                <LinearGradient
                    id="paint0_linear"
                    x1={4.1087}
                    y1={24.0632}
                    x2={21.8607}
                    y2={44.399}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#fff" />
                    <Stop offset={0.644647} stopColor="#fff" stopOpacity={0} />
                </LinearGradient>
                <ClipPath id="clip0">
                    <Path d="M0 5a5 5 0 015-5h30a5 5 0 015 5v40a5 5 0 01-5 5H5a5 5 0 01-5-5V5z" fill="#fff" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgImageIcon
